import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';

if ('serviceWorker' in navigator) {
  try {
    navigator.serviceWorker.register('/sw-custom.js')
      .then(
        registration => {
          const sw: ServiceWorker | null = registration.installing || registration.waiting || registration.active;
          if (sw) {
            sw.postMessage({milliseconds: Date.now()});
          }
        }
      );

    navigator.serviceWorker.addEventListener('updatefound', () => {
    });
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement du Service Worker:', error);
  }
}

platformBrowser().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true,
})
  .catch(err => console.error(err));
